import { Component, Input, OnInit, ElementRef, ChangeDetectorRef, ViewChild } from '@angular/core';
import { RoutingService, I18nModule } from '@spartacus/core';
import { CustomProductsService } from '../custom-products.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { DatePipe, NgIf, NgStyle, NgFor, UpperCasePipe } from '@angular/common';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SubmitQuoteModel } from '../../../../core/model/submit-quote-model';
import { ModalConfig } from '../../../../core/model/modal.config-model';
import { ConfirmBidModalComponent } from '../../../../shared/components/confirm-bid-modal/confirm-bid-modal.component';
import { CustomLoginService } from 'src/app/modules/custom-login/custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { TwoDigitDecimaNumberDirective, allowPositiveAndNegativeNumbersDirective } from '../../../../shared/components/two-digit-decima-number.directive';
@Component({
    selector: 'app-custom-product-card',
    templateUrl: './custom-product-card.component.html',
    styleUrls: ['./custom-product-card.component.scss'],
    imports: [NgIf, NgStyle, FormsModule, TwoDigitDecimaNumberDirective, allowPositiveAndNegativeNumbersDirective, NgFor, ConfirmBidModalComponent, UpperCasePipe, I18nModule]
})
export class CustomProductCardComponent implements OnInit {
  @ViewChild('modal') private modalComponent: ConfirmBidModalComponent;
  public modalConfig: ModalConfig;
  submitQuoteModel = new SubmitQuoteModel();
  @Input() port: any;
  @Input() productInfo: any;
  @Input() browseType: any;
  @Input() portData: any;
  showQualityCard = false;
  showPart1 = true;
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  qualityChunked = [];
  selectedPart = 0;
  myInput: any;
  quantitySelected: any;
  actualQuantitySelected:number;
  selctedToggleBtn = 0;
  quantityRangeArrya: any = [];
  modal = false;
  sliderValueSelected = 0;
  modalData: any;
  showquantity = false;
  closeResult = '';
  timeSelected: any;
  productPrice: any;
  qtyEmptyErr: boolean=false;
  qtyValidErr: boolean=false;
  writeAccess: any;
  isCustomerEmulated: boolean;
  isPlaceBidDisabled: boolean;
  minQty:number;
  maxQty:number;
  maxLen:number;
  constructor(private cd: ChangeDetectorRef,
              private customProductService: CustomProductsService,
              private customloginservice:CustomLoginService,private csAgentAuthService:CsAgentAuthService) {
                
               }

  ngOnInit(): void {
    
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isPlaceBidDisabled = true;
        }else{
          this.isPlaceBidDisabled = false;
        }
      })
    })
  
    this.minQty = this.productInfo.minimumQty;
    this.maxQty= this.productInfo.maximumQty;
    this.maxLen=this.maxQty.toString().length+1;

    this.quantitySelected = '';
    // this.actualQuantitySelected = Number(this.productInfo.tradableBalance);
    // if(this.actualQuantitySelected<this.productInfo.minimumQty)
    // {
    //   this.showquantity = true;
    // }
    this.cd.detectChanges();
    //not required
    // if (this.productInfo.maximumQty !== undefined) {
    //   const quantityRangeMin = this.productInfo.minimumQty;
    //   const quantityRangeMax = this.productInfo.maximumQty / quantityRangeMin;
    //   this.showPart1 = true;
    //   for (let i = 1; i <= quantityRangeMax; i++) {
    //     this.quantityRangeArrya.push(quantityRangeMin * i);
    //   }
    // }
    this.productPrice = this.productInfo.price !== undefined ? this.productInfo.price.value : '';
  }
  omitSpecialChar(event): any {
    const k = event.charCode;
    return this.isValidLetter(k);
  }

  getSliderValue(event): any {
    this.sliderValueSelected = event.target.value;
  }

  isValidLetter(k): any {
    return ((k >= 48 && k <= 57));
  }

  counter(i: number): any {
    return new Array(i);
  }
  validateDecimalPointPrice(e): any{
    const t = e.target.value;
    this.productInfo.priceValue = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 2)) : t;
    // this.cd.detectChanges();
  }
  viewQuality(): any {
    this.qualityChunked = [];
    if (this.productInfo.features){
    const qualityArrya = this.productInfo.features.entry;
    const size = 8;
    // tslint:disable-next-line:typedef
    qualityArrya.sort(function(a, b) {
      const textA = a.value;
      const textB = b.value;
      return (textA < 0) ? -1 : (textB < 0) ? 1 : textB-textA;
  });
    for (let i = 0;  i < qualityArrya.length; i += size) {
      this.qualityChunked.push(qualityArrya.slice(i, i + size));
    }
  }else {
    this.productInfo.noQualityDetails = true;
  }
    this.showQualityCard = !this.showQualityCard;
  }

  toggleQualityPart1(): any {
    this.showPart1 = true;
  }

  toggleQualityPart2(): any {
    this.showPart1 = false;
  }

  toggleQualityPart(selectedIndex): any {
    this.selectedPart = selectedIndex;
    this.showPart1 = false;
  }

  modalid(k): any {
    return k;
  }

  isValid(item: string): any {
    return Object.keys(item).length;
    // return objectKeys(item).length>0?true:false
  }

  isVisible(item: string): any {
    return Object.keys(item).length > 0 ? 'visible' : 'hidden';
  }

  homeLinkClick(value): any {
    this.customProductService.getHomeLinkActive(value);
  }
  // tslint:disable-next-line:typedef
  async openModal(content?: any, data?: any) {
    // if(this.productInfo.price.value>this.productPrice){
    //   alert('price should be grater')
    //     return false;
    // }else{
   
    let qtyCheck;
    qtyCheck = this.checkQtyValidation();
    if(qtyCheck===false){
      if (this.browseType === 'port') {
        data.portName = this.port.name;
      } else if (this.browseType === 'browseAll') {
        if (data.ports.length > 0){
          data.portName = data.ports[0].name;
        }else{
          data.portName = '';
        }
      }
      else if (this.browseType === 'productType') {
        if (data.ports.length > 0){
          data.portName = data.ports[0].name;
        }else{
          data.portName = '';
        }
      }

      // if (data.maximumQty !== undefined && data.minimumQty !== undefined) {
      //   data.maximumQty = data.maximumQty;
      //   data.minimumQty = data.minimumQty;
      // }
      data.priceValue = this.productPrice;
      data.quantitySelected = this.quantitySelected;
      //data.actualQuantitySelected = this.actualQuantitySelected;
      return await this.modalComponent.open(content, data);
    }

      
    // }
  }
  checkPriceValidation($event){
    var s = $event.target.value.split('.');
    if (s.length === 1){
      if (s[0].length >=6) {
        $event.preventDefault();
      }
    }
  }

  checkQtyValidation(){
    let priceToCheck
    //this.showquantity?priceToCheck = this.actualQuantitySelected:
    priceToCheck=this.quantitySelected;
    
    if(priceToCheck === null){
      this.qtyEmptyErr = true;
    }else{
      if(Number(this.minQty)<=Number(priceToCheck) && Number(this.maxQty)>=Number(priceToCheck)){
        //QTY SHOULD BE BETWEEN 2K-50K
        this.qtyValidErr = false;
      }else{
        this.qtyValidErr = true;

      }
      this.qtyEmptyErr = false;
    }
    let flag =this.qtyEmptyErr||this.qtyValidErr;
    return flag;
  }
  
}
